import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import * as cookie from 'cookie';

export const disclaimerGuard: CanActivateFn = (
  route,
  state,
): boolean | UrlTree => {
  const cookies = document.cookie;
  const parsedCookies = cookie.parse(cookies);
  const hasAcceptedDisclaimer = parsedCookies['disclaimerAccepted'];

  if (hasAcceptedDisclaimer) {
    return true; // Allow navigation to proceed to destination
  } else {
    const router: Router = inject(Router); // Use injector to access Router
    return router.createUrlTree(['/terms-of-use'], {
      queryParamsHandling: 'merge', // Preserve or merge query params
    }); // Redirect to terms-of-use page if the cookie is not set
  }
};
